import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/post', //?id=
    name: 'postIndex', //帖子详情
    meta: {
      title: '',
    },
    component: () => import('@/views/post/index.vue'),
  },
  {
    path: '/post/video', //?id=
    name: 'videoPost',
    meta: {
      title: '长城汽车', //视频帖子
    },
    component: () => import('@/views/post/video.vue'),
  },
  {
    path: '/rontePlan', //?id=
    name: 'rontePlan', //路书详情
    meta: {
      title: '长城汽车',
    },
    component: () => import('@/views/rontePlan/index.vue'),
  },
  {
    path: '/ronteList', //?id=
    name: 'ronteList', //路书列表
    meta: {
      title: '',
    },
    component: () => import('@/views/rontePlan/list/index.vue'),
  },
  {
    path: '/vote', //?id=
    name: 'vote', //投票
    meta: {
      title: '',
    },
    component: () => import('@/views/vote/index.vue'),
  },
  {
    path: '/test', //?id=
    name: 'test',
    meta: {
      title: '测试页面',
    },
    component: () => import('@/views/demo/index.vue'),
  },
  {
    path: '/travelScene', //?id=
    name: 'test',
    meta: {
      title: '浏览模式测试',
    },
    component: () => import('@/views/demo/travelScene.vue'),
  },
  {
    path: '/download',
    name: 'downloadAPP',
    meta: {
      title: '长城汽车APP下载',
    },
    component: () => import('@/views/downloadPage/index.vue'),
  },
  {
    path: '/dowmForRegist',
    name: 'dowmForRegist',
    meta: {
      title: '长城汽车APP下载', //为邀请注册页面提供
    },
    component: () => import('@/views/downloadPage/dowmForRegist.vue'),
  },
  {
    path: '/dowmForBrand',
    name: 'dowmForBrand',
    meta: {
      title: '长城汽车APP下载', //五品牌下架 放在五品牌app内的引导下载长城app页 brand=wey
    },
    component: () => import('@/views/downloadPage/brand.vue'),
  },
  {
    path: '/picView',
    name: 'picView',
    meta: {
      title: '', //单图片加载页
    },
    component: () => import('@/views/picView/index.vue'),
  },
]

export default routes
